/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';

import startCase from 'lodash/startCase';
import clsx from 'clsx';
import DetailsList from '../DetailsList';
import Link from '../Link';
import styles from './AdjustmentsTasksList.style';
import appStyles from '../../App.style';

const columns = [
  {
    key: 'Action Required',
    name: 'Action Required',
    isResizable: false,
    isIconOnly: true,
    minWidth: 10,
    maxWidth: 10,
    onRender: (task, index) => (
      <>
        <div className={styles.secondaryIconColumnFlex}>
          <FontIcon
            className={clsx(styles.actionRequiredIcon, appStyles.defaultColor)}
            iconName="StatusCircleExclamation"
            ariaLabel="TextDocument"
            id={`actionRequiredIcon${index}`}
          />
        </div>
      </>
    ),
  },
  {
    key: 'name',
    name: 'Adjustment Name',
    fieldName: 'name',
    isResizable: false,
    minWidth: 200,
    maxWidth: 200,
    onRender: task => task.resource?.name,
  },
  {
    key: 'status',
    name: 'Status',
    fieldName: 'status',
    isResizable: false,
    minWidth: 200,
    maxWidth: 200,
    onRender: task => startCase(task.resource?.status),
  },
  {
    key: 'type',
    name: 'Adjustment Type',
    fieldName: 'type',
    isResizable: false,
    minWidth: 200,
    maxWidth: 200,
    onRender: task => startCase(task.resource?.type),
  },
  {
    key: 'contractId',
    name: 'Contract Id',
    fieldName: 'contractId',
    isResizable: false,
    minWidth: 100,
    maxWidth: 100,
    onRender: task => task.resource?.contractId,
  },
  {
    key: 'reviewLink',
    name: 'Review',
    fieldName: 'review',
    isResizable: false,
    minWidth: 150,
    maxWidth: 150,
    onRender: task => (
      <Link
        href={`/adjustments/${task.resourceId}`}
        aria-label="task review"
        data-testid="adjustment-task-review-link"
        className={styles.button}
      >
        {task.resource?.status === 'Draft' && (
          <Text data-testid={`review-and-resubmit-${task.resourceId}`}>Review and Resubmit</Text>
        )}
        {task.resource?.status === 'ApprovalRequested' && (
          <Text data-testid={`review-and-approve-${task.resourceId}`}>Review and Approve</Text>
        )}

        {task.operation === 'reversal-submit-for-approval' && (
          <Text data-testid={`review-and-approve-reversal-${task.resourceId}`}>
            Review and Approve Reversal
          </Text>
        )}
        <FontIcon iconName="ChevronRight" className={styles.rightIcon} />
      </Link>
    ),
  },
];

const AdjustmentsTasksList = ({ items, className, ...other }) => (
  <DetailsList
    items={items.map(task => {
      return {
        ...task,
        key: task.key,
        link: `/adjustments/${task.resourceId}`,
        dataAutomationId: `row-${task._id}`,
      };
    })}
    columns={columns}
    className={className}
    {...other}
  />
);

AdjustmentsTasksList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      contractId: PropTypes.string,
      dataAutomationId: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
};

AdjustmentsTasksList.defaultProps = {
  items: [],
  className: '',
};

export default AdjustmentsTasksList;
